import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../components/layout';
import Box from 'components/box';
import Title from 'components/title';
import Gallery from 'components/gallery';
import IOExample from 'components/io-example';
import ContactForm from 'components/forms/contact-form';
import Modal from 'containers/modal';
import Example from 'components/bootstrap-modal'
import { graphql } from 'gatsby';

const Index = ({ data }) => (
  <Layout>

    <Box>
      <Title as="h2" size="large">
        {data.homeJson.content.childMarkdownRemark.rawMarkdownBody}
      </Title>
      {/*<Modal>*/}
      {/*  <video*/}
      {/*    src="https://i.imgur.com/gzFqNSW.mp4"*/}
      {/*    playsInline*/}
      {/*    loop*/}
      {/*    autoPlay*/}
      {/*    muted*/}
      {/*  />*/}
      {/*</Modal>*/}


    </Box>
    {/*<Modal>*/}
    {/*  <div>Something in here</div>*/}
    {/*</Modal>*/}
    {/*<Box>*/}
    {/*  <Title as="h2" size="large">Technologies</Title>*/}
    {/*</Box>*/}
    <Gallery items={data.homeJson.gallery} />
    <Box>
      <Title as="h2" size="large">Clients</Title>
    </Box>
    <Gallery items={data.homeJson.clientGallery} />
    {/*<div style={{ height: '50vh' }} />*/}

    <Box>
      <Title as="h2" size="large">Get in touch</Title>
    </Box>
    {/*<Example />*/}
    <ContactForm />


    {/*<form action="https://getform.io/f/aeeb3c98-feae-4836-9b4a-20d8d861778e" method="POST">*/}
    {/*  <label>Name*/}
    {/*  <input type="text" name="name" />*/}
    {/*  </label>*/}
    {/*  <label> Email*/}
    {/*    <input type="email" name="email" />*/}
    {/*    </label>*/}
    {/*  <label>*/}
    {/*  <input type="text" name="message" />*/}
    {/*  <button type="submit">Send</button>*/}
    {/*  </label>*/}
    {/*</form>*/}
    <IOExample />
  </Layout>
);

Index.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Index;
// @todo ...
export const query = graphql`
  query HomepageQuery {
    homeJson {
      title
      content {
        childMarkdownRemark {
          html
          rawMarkdownBody
        }
      }
      gallery {
        title
        copy
        image {
          childImageSharp {
            fluid(maxHeight: 500, quality: 90) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        modalCopy
      }
      clientGallery {
        title
        copy
        image {
          childImageSharp {
            fluid(maxHeight: 500, quality: 90) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        modalCopy
      }
    }
  }
`;
